import React, { useEffect, useState } from 'react';
import { setConfirmHandler } from '../utils/appConfirm';
import './ConfirmDialog.css';

export default function ConfirmDialog() {
  const [request, setRequest] = useState(null);

  useEffect(() => {
    setConfirmHandler((next) => setRequest(next));
    return () => setConfirmHandler(null);
  }, []);

  if (!request) return null;

  const close = (ok) => {
    const resolve = request.resolve;
    setRequest(null);
    resolve(Boolean(ok));
  };

  return (
    <div
      className="app-confirm-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="app-confirm-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) close(false);
      }}
    >
      <div className="app-confirm-box">
        <div className="app-confirm-header">
          <h3 id="app-confirm-title">{request.title}</h3>
          <button
            type="button"
            className="app-confirm-close"
            onClick={() => close(false)}
            aria-label="Cancel"
          >
            ✕
          </button>
        </div>
        <p className="app-confirm-text">{request.message}</p>
        <div className="app-confirm-actions">
          <button
            type="button"
            className="app-confirm-cancel"
            onClick={() => close(false)}
          >
            {request.cancelLabel}
          </button>
          <button
            type="button"
            className={`app-confirm-ok${request.danger ? ' app-confirm-ok--danger' : ''}`}
            onClick={() => close(true)}
          >
            {request.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
